<template>
  <div class="d-flex justify-end">
    <v-btn class="search-button" outlined color="success" @click="exportExcel">
      <v-icon left>mdi-file-excel</v-icon> Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import { headerExcel } from '@/modules/tuitionFee/detail-period/helper/headerStudent'
import utils from '@/plugins/utils'
import { mapGetters, mapActions } from 'vuex'
import { get } from 'lodash'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      ownClassIds: 'auth/ownClassIds',
      user: 'auth/user',
      customQuery: 'tuitionFeeReport/customQuery',
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
    }),
  },
  methods: {
    ...mapActions({
      exportDataExcel: 'tuitionFeeReport/exportDataExcel',
    }),
    async exportExcel() {
      this.$loading.active = true
      try {
        let params = {
          ...this.customQuery,
          period: this.detailPeriod.id,
          class_in: this.user.role.type === 'teacher' ? this.ownClassIds : null,
        }
        const listReport = await this.exportDataExcel(params)
        let filter = this.$options.filters
        const data = listReport.map(item => {
          item.name = item.student.name
          item.code = filter.getStudentCode(item.student.code)
          item.class = item.class && item.class.title
          item.notes = item.notes || ''
          item.totalAmount = get(item, 'totalAmount', 0)
          item.amountPaid = get(item, 'amountPaid', 0)
          item.amountDebt = get(item, 'amountDebt', 0)
          return item
        })
        utils.exportExcel(
          data,
          headerExcel,
          `Danh sách học sinh tổng kết kì đóng ${filter.convertFullDate(this.detailPeriod.title)}`
        )
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
